import React, { useState, useEffect } from "react";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../../env";

function ItemMaster() {

  const [items, setItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [mode, setMode] = useState("view");
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null); 
  const [form, setForm] = useState({
    CategoryId: "",
    SubCategoryId: "",
    ItemName: "",
  });
  useEffect(() => {
    loadItems();
    loadCategories();
  }, []);
  const loadItems = async () => {
    const res = await axios.post(`${REACT_APP_API_URL}api/inventory/item`, {
      action: "ITEM_V"
    });
    setItems(res.data);
  };
  const loadCategories = async () => {
    const res = await axios.post(`${REACT_APP_API_URL}api/inventory/item`, {
      action: "CAT_V"
    });
    setCategories(res.data);
  };
  const loadSubCategories = async (catId) => {
    const res = await axios.get(
      `${REACT_APP_API_URL}api/inventory/item?action=ITEM_SC&categoryId=${catId}`
    );
    setSubCategories(res.data);
  };
  const handleSubmit = async (e) => {
  e.preventDefault();
  const itemName = form.ItemName.trim();
  if (!form.CategoryId) {
    alert("Please select category");
    return;
  }
  if (!form.SubCategoryId) {
    alert("Please select sub category");
    return;
  }
  if (!itemName) {
    alert("Item Name is required");
    return;
  }
  if (itemName.length < 3) {
    alert("Item Name must be at least 3 characters");
    return;
  }
  const nameRegex = /^[A-Za-z\s]+$/;
  if (!nameRegex.test(itemName)) {
    alert("Only alphabets allowed");
    return;
  }
  const scriptRegex = /<script.*?>.*?<\/script>/gi;
  if (scriptRegex.test(itemName)) {
    alert("Invalid Item Name");
    return;
  }
  const duplicate = items.some(
    (i) =>
      i.ItemName.toLowerCase() === itemName.toLowerCase() &&
      Number(i.ItemCategoryId) === Number(form.CategoryId) &&
      Number(i.ItemSubCategoryId) === Number(form.SubCategoryId) &&
      Number(i.ItemID || i.ItemId) !== Number(editId)
  );
  if (duplicate) {
    alert("Item already exists");
    return;
  }
  try {
    const action = editId ? "ITEM_U" : "ITEM_A";
    await axios.post(
      `${REACT_APP_API_URL}api/inventory/item`,
      {
        action,
        ItemId: editId ? Number(editId) : 0,
        CategoryId: Number(form.CategoryId),
        SubCategoryId: Number(form.SubCategoryId),
        ItemName: itemName
      }
    );
    alert(editId ? "Item Updated" : "Item Added");
    resetForm();
    loadItems();
  } catch (error) {
    console.error(error);
    alert("Something went wrong");
  }
};
  const handleEdit = (item) => {
  const id = item.ItemID || item.ItemId;
  if (!id) {
    alert("Invalid Item ID");
    return;
  }
  console.log("Editing:", id); 
  setEditId(Number(id)); 
  setForm({
    CategoryId: item.ItemCategoryId,
    SubCategoryId: item.ItemSubCategoryId,
    ItemName: item.ItemName,
  });
  loadSubCategories(item.ItemCategoryId);
  setShowModal(true);
};
 const handleDelete = async (id) => {
  try {
    if (!id || isNaN(id)) {
      alert("Invalid ID");
      return;
    }
    if (!window.confirm("Delete this item?")) return;
    await axios.post(
      `${REACT_APP_API_URL}api/inventory/item`,
      {
        action: "ITEM_D",
        ItemIds: String(id)
      }
    );
    alert("Item Deleted");
    loadItems();
  } catch (error) {
    console.error(error);
    alert("Delete failed");
  }
};
  const resetForm = () => {
    setForm({
      CategoryId: "",
      SubCategoryId: "",
      ItemName: "",
    });
    setEditId(null);
    setShowModal(false);
  };
  return (
    <div className="container-fluid p-4">
      <div className="card shadow-sm border-0">
        <div className="card-body">
          <div className="mb-3">
            <button
              className={`btn ${mode === "add" ? "btn-primary" : "btn-outline-primary"} me-2`}
              onClick={() => setMode("add")}
            >
              Add
            </button>
            <button
              className={`btn ${mode === "view" ? "btn-primary" : "btn-outline-primary"}`}
              onClick={() => setMode("view")}
            >
              View
            </button>
          </div>
          {mode === "add" && (
            <div className="text-center p-4">
              <button
                className="btn btn-success"
                onClick={() => {
                  resetForm();
                  setShowModal(true);
                }}
              >
                + Add Item
              </button>
            </div>
          )}
          {mode === "view" && (
            <>
              <h5>Item List</h5>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Category</th>
                    <th>SubCategory</th>
                    <th>Item</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((item, i) => (
                    <tr key={item.ItemID || item.ItemId}>
                      <td>{i + 1}</td>
                      <td>{item.ItemCategoryName}</td>
                      <td>{item.ItemSubCategoryName}</td>
                      <td>{item.ItemName}</td>
                      <td>
                        <button
                          className="btn btn-sm btn-primary me-2"
                          onClick={() => handleEdit(item)}
                        >
                          ✏️
                        </button>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleDelete(item.ItemID || item.ItemId)}
                        >
                          🗑️
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
        </div>
      </div>
      {showModal && (
        <>
          <div className="modal d-block">
            <div className="modal-dialog">
              <div className="modal-content p-3">
                <div className="modal-header">
                  <h5>{editId ? "Edit Item" : "Add Item"}</h5>
                  <button className="btn-close" onClick={resetForm}></button>
                </div>
                <form onSubmit={handleSubmit}>
                  <select
                    className="form-control mb-2"
                    value={form.CategoryId}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        setForm({
                          ...form,
                          CategoryId: value,
                          SubCategoryId: ""
                        });
                        if (value) {
                          loadSubCategories(value);
                        }
                      }
                    }}
                    required
                  >
                    <option value="">Select Category</option>
                    {categories.map(c => (
                      <option key={c.ItemCategoryId} value={c.ItemCategoryId}>
                        {c.ItemCategoryName}
                      </option>
                    ))}
                  </select>
                  <select
                    className="form-control mb-2"
                    value={form.SubCategoryId}
                    onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                          setForm({
                            ...form,
                            SubCategoryId: value
                          });
                        }
                      }}
                    required
                  >
                    <option value="">Select SubCategory</option>
                    {subCategories.map(sc => (
                      <option key={sc.ItemSubCategoryId} value={sc.ItemSubCategoryId}>
                        {sc.ItemSubCategoryName}
                      </option>
                    ))}
                  </select>
                  <input
                    className="form-control mb-2"
                    placeholder="Item Name"
                    maxLength={50}
                    value={form.ItemName}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^[A-Za-z\s]*$/.test(value)) {
                        setForm({
                          ...form,
                          ItemName: value
                        });
                      }
                    }}
                    required
                  />
                  <button className="btn btn-success w-100">
                    {editId ? "Update" : "Submit"}
                  </button>
                </form>
              </div>
            </div>
          </div>
          <div className="modal-backdrop show"></div>
        </>
      )}
    </div>
  );
}

export default ItemMaster;